import { render, staticRenderFns } from "./ServiceAssistantList.vue?vue&type=template&id=ecc7e42a"
import script from "./ServiceAssistantList.vue?vue&type=script&lang=js"
export * from "./ServiceAssistantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports